import Parcel from "single-spa-react/parcel";
import React, { useCallback, useState } from "react";
import "systemjs";

export const useSingleSpaParcel = (importName: string, parcelProps: {}) => {
    let forceUpdate = useForceUpdate();

    let url = System.getImportMap().imports?.[importName];
    if (typeof url === "undefined") {
        setTimeout(() => {
            forceUpdate();
        }, 10);
        return null;
    }

    let endpoint = new URL(url).origin;
    let parcelConfig = System.import(importName);

    return (
        <Parcel
            config={parcelConfig}
            endpoint={endpoint}
            mountParcel={(window as any).singleSpa.mountRootParcel}
            {...parcelProps}
        />
    );
};

function useForceUpdate() {
    let [, updateState] = useState<any>();
    return useCallback(() => updateState({}), []);
}
